<template>
  <div
    :class="cssClasses()"
    class="loader-wrapper"
  />
</template>

<script>
import PubSub from '@helper/PubSub'

export default {
  name: 'Loader',
  props: {
    isActiveInitially: {
      type: Boolean,
      default: () => false,
    },
  },
  data() {
    return {
      isActive: this.isActiveInitially,
    }
  },
  created () {
    PubSub.subscribe('show-loader', (_data) => {
      this.show()
    })

    PubSub.subscribe('hide-loader', () => {
      this.hide()
    })
  },
  methods: {
    show () {
      this.isActive = true
    },
    hide () {
      this.isActive = false
    },
    cssClasses () {
      return {
        error: this.error,
        'show-loader': this.isActive,
      }
    },
  },
}
</script>

<style lang="scss" scoped>
  @import "styles/index";
</style>
